import { ReactNode } from 'react';
import { PRIMARY_BLACK } from 'src/global/theme/colors';

import styles, { VARIANTS } from './styles';

export type TEXT_ALIGN = 'left' | 'right' | 'center' | 'justify';

export type TextProps = {
  variant?: VARIANTS;
  color?: string;
  textAlign?: TEXT_ALIGN;
  style?: Omit<React.CSSProperties, 'fontSize' | 'lineHeight' | 'color' | 'textAlign'>;
  children: ReactNode;
  className?: string;
};

function Text({
  variant = 'Caption-Regular',
  color = PRIMARY_BLACK,
  textAlign = 'left',
  style,
  children,
  className,
  ...rest
}: Readonly<TextProps>) {
  return (
    <div
      style={{
        ...styles[variant],
        color,
        textAlign,
        ...style
      }}
      className={className}
      {...rest}>
      {children}
    </div>
  );
}

export default Text;
